import { toPng } from "html-to-image";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as service from "../services/employeeApi";
import { setIsLoading, setOrganizationStructure } from "../slices/employeeSlice";

function simplifyArrayToNested(array) {
  const map = new Map();
  const result = [];

  for (const obj of array) {
    obj.children = [];
    map.set(obj.organizationId, obj);
  }

  for (const obj of array) {
    if ((obj.under.organizationId || obj.under.organizationId === "") && map.has(obj.under.organizationId)) {
      const parent = map.get(obj.under.organizationId);
      parent.children.push(obj);
    } else {
      result.push(obj);
    }
  }

  return result;
}

function useEmployeeEmploymentOrganizationStructure() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { currentCompany, currentEmployee } = useSelector((state) => state.company);
  const isLoading = useSelector((state) => state.employee.isLoading);

  const getOrganizationStructure = useCallback(
    async () => {
      try {
        dispatch(setIsLoading(true));
        const response = await service.getOrganizationStructure({
          companyId: currentCompany,
          employeeId: id
        })
        dispatch(setOrganizationStructure(simplifyArrayToNested(response.data)))
      } catch (error) {
        console.log(error);
      } finally {
        dispatch(setIsLoading(false));
      }
    }, [currentCompany, currentEmployee, dispatch]
  )

  useEffect(() => {
    getOrganizationStructure()
  }, [getOrganizationStructure])


  const onDownload = () => {
    const chartElement = document.getElementById('employmentOrganizationStructure');

    var originalWidth = chartElement.style.width;
    var originalHeight = chartElement.style.height;
    chartElement.style.width = chartElement.scrollWidth + 'px';
    chartElement.style.height = chartElement.scrollHeight + 'px';

    toPng(chartElement)
      .then((dataUrl) => {
        chartElement.style.width = originalWidth;
        chartElement.style.height = originalHeight;
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'employmentOrganizationStructure.png';
        link.click();
      })
      .catch((error) => {
        console.error('Could not generate image', error);
      });
  };

  return {
    isLoading,
    onDownload
  }

}



export default useEmployeeEmploymentOrganizationStructure;
